// src/utils/sharedRead.js
// Lets callers that start the same big read at nearly the same moment share one
// network download instead of each pulling the data again.
//
// Why: on launch the home screen asked for the whole `deals` collection three
// times in the same instant (the dashboard shell, the home hero and the File
// Requests queue), so a phone downloaded every deal three times before the
// screen settled.
//
// Safety: a caller only joins a read that is still in flight AND started less
// than `windowMs` ago; once a read finishes, the next caller starts a fresh one.
// Only launch-time loads opt in (see firebasefunctions.js). A refresh after a
// save never does, so it can never be handed data from before that save.
const inFlight = new Map();

export function shareRead(key, read, { windowMs = 5000, now = Date.now } = {}) {
  const startedAt = now();
  const current = inFlight.get(key);
  if (current && startedAt - current.startedAt < windowMs) return current.promise;

  let promise;
  try {
    promise = Promise.resolve(read());
  } catch (err) {
    promise = Promise.reject(err);
  }
  const entry = { startedAt, promise };
  inFlight.set(key, entry);
  const clear = () => {
    if (inFlight.get(key) === entry) inFlight.delete(key);
  };
  promise.then(clear, clear);
  return promise;
}
